export default {
  HELLO: 'Olá, ',
  SENDED_INFO: 'A seguradora já nos enviou as informações da sua proposta e elas estão aqui para que você possa conferir e finalizar a compra.',
  PAYMENT_IN: 'Como foi acordado com seu corretor, o pagamento será feito em ',
  USING_BALANCE: ' utilizando o saldo da sua carteira.',
  USING_CREDIT: ' no seu cartão de crédito',
  USING_OPENFINANCE: ' no Pix.',
  USING_POINTS: ' com pontos.',
};
